import { isNil } from 'lodash'
import React, { type FC, useState } from 'react'
import { t } from 'i18next'
import { type Track } from './types'
import { Alert, AlertDialog, Select, SelectItem } from '@awell-health/design-system'

interface StartTrackModalProps {
  onClose: () => void
  onStartTrack: (trackId: string) => void
  tracks: Array<Track> | undefined
}

export const StartTrackModal: FC<StartTrackModalProps> = ({ onClose, onStartTrack, tracks = [] }) => {
  const [track, setTrack] = useState<SelectItem>()

  const handleAction = (): void => {
    if (!isNil(track)) {
      onStartTrack(track.value as string)
      onClose()
    }
  }

  return (
    <div>
      <AlertDialog
        className="min-w-[400px] min-h-[450px]"
        title={t('add_track_heading')}
        button={{
          label: t('add_track'),
          buttonAction: handleAction
        }}
        secondaryButton={{
          label: t('cancel'),
          buttonAction: onClose
        }}
      >
        <div className="flex flex-col gap-5">
          <div></div>
          <Alert variant="warning" title={t('add_track_delay_warning')} showIcon={true} />
          <div className="min-h-[100px]">
            <Select
              label={t('add_track_label')}
              handleChange={(value: SelectItem | SelectItem[]) => {
                setTrack(value as SelectItem)
              }}
              isSearchable={true}
              isClearable={true}
              isMulti={false}
              value={track}
              menuShouldBlockScroll={true}
              disabled={tracks.length === 0}
              placeholder={tracks.length === 0 ? t('add_track_no_options') : undefined}
              options={tracks.map(track => ({ label: track.title, value: track.id }))}
            ></Select>
          </div>
        </div>
      </AlertDialog>
    </div>
  )
}
